document.addEventListener("DOMContentLoaded", function () {
  const megamenuTriggerMenu = document.getElementById("HeaderMenu-terroir");
  const megamenuTriggerDrawer = document.getElementById("HeaderDrawer-terroir");
  const megamenu = document.getElementById("megamenu");
  const closeBar = document.querySelector(".close-bar");
  const headerContainer = document.querySelector(".header-wrapper");

  // Find the span child inside the megamenuTriggerMenu
  const megamenuTriggerMenuSpan = megamenuTriggerMenu.querySelector("span");

  let previousActiveSpan = null;

  // Calculate the top position based on the utility bar's height
  const utilityBarHeight = 0;
  const headerHeight = headerContainer.offsetHeight;
  //megamenu.style.top = `${0 - utilityBarHeight}px`;
  megamenu.style.top = `-1px`;
  megamenu.style.height = `calc(100vh - ${utilityBarHeight + headerHeight}px)`;

  function toggleMegamenu(event) {
    console.log('click terroir');
    event.preventDefault();

    document.body.style.overflow = "hidden";
    megamenu.classList.toggle("show");
    megamenu.style.transform = `translateY(${utilityBarHeight + headerHeight}px)`;

    if (megamenu.classList.contains("show")) {
      // Remove the active class from any other span that has it
      const activeSpan = document.querySelector('.header__active-menu-item');
      if (activeSpan && activeSpan !== megamenuTriggerMenuSpan) {
        activeSpan.classList.remove("header__active-menu-item");
        previousActiveSpan = activeSpan; // Save the previous active span
      }

      // Add the active class to the current span
      megamenuTriggerMenuSpan.classList.add("header__active-menu-item");
    } else {
      // Remove the active class when megamenu is closed
      megamenuTriggerMenuSpan.classList.remove("header__active-menu-item");

      // Restore the previous active span if there was one
      if (previousActiveSpan) {
        previousActiveSpan.classList.add("header__active-menu-item");
      }
    }
  }

  // Attach event listeners to both megamenu triggers
  megamenuTriggerMenu.addEventListener("click", toggleMegamenu);
  megamenuTriggerDrawer.addEventListener("click", toggleMegamenu);

  // Close the megamenu when clicking outside of it
  document.addEventListener("click", function (event) {
    if (
      !megamenu.contains(event.target) &&
      !megamenuTriggerMenu.contains(event.target) &&
      !megamenuTriggerDrawer.contains(event.target) &&
      !closeBar.contains(event.target)
    ) {
      closeMegamenu();
    }
  });

  // Close the megamenu when the close-bar is clicked
  closeBar.addEventListener("click", function () {
    closeMegamenu();
  });

  function closeMegamenu() {
    megamenu.classList.remove("show");
    document.body.style.overflow = "";
    megamenu.style.transform = `translateY(-100%)`;

    // Remove the active class from the current span
    megamenuTriggerMenuSpan.classList.remove("header__active-menu-item");

    // Restore the previous active span if there was one
    if (previousActiveSpan) {
      previousActiveSpan.classList.add("header__active-menu-item");
    }
  }
});